import { useSearchParams } from "react-router-dom";
import Reveal from "@/components/Reveal";
import ApplicationForm from "@/components/ApplicationForm";

export default function Apply() {
  const [params] = useSearchParams();
  const defaultDomain = params.get("domain") || "";

  return (
    <div className="pt-24 md:pt-32">
      <section className="max-w-7xl mx-auto px-6 md:px-10 pb-24 md:pb-32">
        <Reveal>
          <span className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-[0.24em] text-neutral-500">
            <span className="inline-block w-6 h-px bg-neutral-400" />
            Apply for Internship
          </span>
          <h1 className="mt-6 font-serif text-5xl md:text-6xl lg:text-7xl leading-[0.98] tracking-tight max-w-5xl">
            Two minutes to your career launchpad.
          </h1>
          <p className="mt-8 text-lg text-neutral-600 max-w-3xl leading-relaxed">
            Fill in a few details and our team reviews your profile within 24 hours. Shortlisted
            candidates receive an official Internship Offer Letter from Scontinent Technologies.
          </p>
        </Reveal>

        <div className="mt-16">
          <ApplicationForm defaultDomain={defaultDomain} />
        </div>
      </section>
    </div>
  );
}
